'use client';

import { useDynamicContext } from '@dynamic-labs/sdk-react-core';
import { useChannel } from 'ably/react';
import { useSetAtom } from 'jotai';
import Image from 'next/image';
import { useMemo } from 'react';

import { Metadata } from '@repo/types-client';
import { getImageUrl } from '@repo/utils';

import { isAirdroppingAtom } from '@claim/atoms';

import { useClaim } from '../../../../../hooks/use-claim';
import { ClaimStatus } from './claim-status';

export const InProgress: React.FC = () => {
  const { user } = useDynamicContext();
  const channelName = useMemo(() => `user:${user?.userId}`, [user?.userId]);
  const {
    error,
    isAirdropping,
    isDecompressing,
    compressedBalance,
    fetchBalance,
  } = useClaim();

  const setIsAirdropping = useSetAtom(isAirdroppingAtom);

  const claimAddress = (user?.metadata as Metadata)?.solanaClaimAddress;

  // Channel subscription to handle $dood airdrop
  useChannel(channelName, 'token-claim-completed', (message: any) => {
    if (message) {
      fetchBalance(claimAddress as string);
      setIsAirdropping(false);
    }
  });

  return (
    <>
      <div className='pt-4'>
        <div className='relative w-[524px] max-w-[100vw]'>
          <Image
            src={getImageUrl('/claim/images/radar-dood.gif')}
            alt='LOADING'
            width={524}
            height={524}
            layout='responsive'
          />
        </div>
      </div>

      <div className='w-full rounded-b-[18px] bg-[#171717] px-4 py-5 text-center'>
        {isAirdropping ? (
          <ClaimStatus
            hideIcon
            hideClaimButton
            title='PREPARING YOUR TOKENS'
            status='preparing'
          />
        ) : null}

        {!isAirdropping &&
        !isDecompressing &&
        claimAddress &&
        compressedBalance[claimAddress] &&
        !error ? (
          <ClaimStatus
            title='READY TO CLAIM'
            status='ok'
          />
        ) : null}

        {isDecompressing ? (
          <ClaimStatus
            title='CONFIRM YOUR TRANSACTION'
            subtitle='sign it to claim your $DOOD'
            status='ok'
            hideClaimButton
          />
        ) : null}

        {error ? (
          <ClaimStatus
            status={error === 'Rejected' ? 'rejected' : 'error'}
            title={error === 'Rejected' ? 'SIGNATURE REJECTED' : 'ERROR'}
            subtitle='Claim failed. Please try again.'
          />
        ) : null}
      </div>
    </>
  );
};
